import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowUpRight, Check } from 'lucide-react';
import { LANDING } from 'constants/testIds';

export const CTA = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    // continue to the sign-up concept
    setTimeout(() => navigate('/signup'), 700);
  };

  return (
    <section
      id="about"
      data-testid={LANDING.ctaSection}
      className="relative py-24 md:py-40 overflow-hidden bg-zinc-950"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 grid-lines opacity-40" aria-hidden />
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full opacity-40 blur-3xl"
        style={{ background: 'radial-gradient(circle, rgba(0,229,255,0.18), transparent 70%)' }}
        aria-hidden
      />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative mx-auto max-w-4xl px-6 lg:px-10 text-center"
      >
        <h2 className="font-display font-bold text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tighter text-zinc-50">
          Get started in your
          <br />
          creative journey<span className="text-[#6C63F5]">.</span>
        </h2>
        <p className="mt-8 max-w-xl mx-auto text-zinc-400 text-base md:text-lg leading-relaxed">
          Join 5,000+ creatives and 100+ brands already on Qreativs. Whether
          you&apos;re new to the industry or a name people already know — this is
          where you&apos;ll be found.
        </p>

        {!submitted ? (
          <form
            onSubmit={handleSubmit}
            className="mt-10 flex flex-col sm:flex-row items-stretch gap-3 max-w-lg mx-auto"
          >
            <input
              type="email"
              required
              data-testid={LANDING.ctaEmailInput}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              className="flex-1 rounded-full bg-zinc-900/80 border border-zinc-800 text-zinc-100 placeholder:text-zinc-500 px-5 h-12 text-sm focus:outline-none focus:border-[#6C63F5] focus:ring-2 focus:ring-[#6C63F5]/20 transition-[border-color,box-shadow] shadow-[0_1px_0_rgba(255,255,255,0.04)_inset]"
            />
            <button
              type="submit"
              data-testid={LANDING.ctaPrimaryBtn}
              className="landing-btn landing-btn-primary landing-btn-lg group shrink-0"
            >
              Sign up
              <ArrowUpRight size={16} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
          </form>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="mt-10 inline-flex items-center gap-3 rounded-full border border-[#6C63F5]/30 bg-[#6C63F5]/5 px-6 py-3.5"
          >
            <span className="h-6 w-6 rounded-full bg-[#6C63F5] text-white flex items-center justify-center">
              <Check size={14} strokeWidth={3} />
            </span>
            <span className="text-sm text-zinc-100">You&apos;re on the list. We&apos;ll be in touch soon.</span>
          </motion.div>
        )}

        <div className="mt-6 text-xs text-zinc-500">
          No spam. Unsubscribe any time.
        </div>
      </motion.div>
    </section>
  );
};

export default CTA;
